import React, { useEffect, createElement, Component } from 'react';
import { CONSTANTS } from './utils/constants';
// Components
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { BeforeAfter } from './components/BeforeAfter';
import { ProductPresentation } from './components/ProductPresentation';
import { TargetAudience } from './components/TargetAudience';
import { BonusSection } from './components/BonusSection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  // Initialize Meta Pixel
  useEffect(() => {
    try {
      // @ts-ignore
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ?
          // @ts-ignore
          n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        // @ts-ignore
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        // @ts-ignore
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        // @ts-ignore
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        // @ts-ignore
        s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      // @ts-ignore
      fbq('init', CONSTANTS.META_PIXEL_ID);
      // @ts-ignore
      fbq('track', 'PageView');
    } catch (error) {
      console.error('Error initializing Meta Pixel:', error);
    }
  }, []);
  return <div className="min-h-screen font-sans" data-id="element-0">
      <StickyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SocialProof data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <BeforeAfter data-id="element-5" />
      <ProductPresentation data-id="element-6" />
      <TargetAudience data-id="element-7" />
      <BonusSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
      <PurchasePopup data-id="element-15" />
    </div>;
}